import { BetSlipForShare } from "@api-types/agency/bet-slip/BetSlipForShare";
import { BetSlipCombinations } from "@api-types/bet-slip/BetSlipCombinations";
import { BetSlipStatus } from "@api-types/agency/bet-slip/BetSlipStatus";
import { BetOffer } from "./BetOffer";
import {
	groupOffersByEvent,
	injectIsMultiToOffers,
} from "@utils/my-bets/helpers";

export class BetSlipShare {
	betSlipCombinations: BetSlipCombinations[];
	betSlipOffers: BetOffer[];
	betSlipStatus: BetSlipStatus;
	dateCreated: string;
	maxCoefficient: number;
	groupedOffersByEvent: BetOffer[][];

	constructor(bet: BetSlipForShare) {
		this.betSlipCombinations = bet.betSlipCombinations;
		this.betSlipOffers = bet.betSlipOffers.map(
			(offer) => new BetOffer(offer)
		);
		this.betSlipStatus = bet.betSlipStatus;

		this.dateCreated = bet.dateCreated;
		this.maxCoefficient = bet.maxCoefficient;
		this.groupedOffersByEvent = groupOffersByEvent(this.betSlipOffers);
		injectIsMultiToOffers(this.groupedOffersByEvent);
	}
}
